module.exports = __webpack_public_path__ + "img/sd_cover.1b594eba.webp";